var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7502 4.16669H6.25016C3.94898 4.16669 2.0835 6.03217 2.0835 8.33335V18.75C2.0835 21.0512 3.94898 22.9167 6.25016 22.9167H18.7502C21.0514 22.9167 22.9168 21.0512 22.9168 18.75V8.33335C22.9168 6.03217 21.0514 4.16669 18.7502 4.16669Z",
    stroke: "black",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 2.08334V6.25001M16.6668 2.08334V6.25001M2.0835 10.4167H22.9168",
    stroke: "black",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.69b7fc7697e6ad4303171d32f0f97372.svg";
export { ForwardRef as ReactComponent };